/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AutomationTemplateQueryTenant extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AutomationTemplateQueryTenant");
    }

    getFixupPrototypeFunction() { return AutomationTemplateQueryTenant.fixupPrototype; }

    static newInstance(model: Partial<AutomationTemplateQueryTenant>): AutomationTemplateQueryTenant {
        let obj = Object.assign(new AutomationTemplateQueryTenant(), model);
        AutomationTemplateQueryTenant.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AutomationTemplateQueryTenant>): AutomationTemplateQueryTenant {
        if (!model) return null;
        return AutomationTemplateQueryTenant.newInstance(<AutomationTemplateQueryTenant> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AutomationTemplateQueryTenant) {
        if (!obj) return;

        models.AutomationTemplateQueryTenant.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AutomationTemplateQueryTenant): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AutomationTemplateQueryTenant.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Tenant of the template
     */
    tenant_ids: Array<string>;

}
